import React, { useEffect, useRef, useState } from 'react';
import { fileSelect } from '../../static/svgs';
import FileMessage from '../documents/FileMessage';
import { supportRequest } from './supportApi';

export default function SupportAttachment({ message }) {
  const [source, setSource] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const resource = useRef(null);
  const mounted = useRef(false);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; if (resource.current) URL.revokeObjectURL(resource.current); }; }, []);
  async function open() {
    setBusy(true);
    try {
      const blob = await supportRequest(`files/${message.id}`, { blob: true });
      if (!mounted.current) return;
      resource.current = URL.createObjectURL(blob);
      setSource(resource.current);
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  }
  return source ? <FileMessage path={message.filename} displayName={message.filename} size={message.size} sourceUrl={source} fileAction={/\.(pdf|png|jpe?g|gif|webp|wav|mp3|m4a)$/i.test(message.filename) ? 'choice' : 'download'} /> :
    <div><button type="button" className="support-attachment manrope-bold" disabled={busy} onClick={open}>{fileSelect}<span>{message.filename}{busy ? ' · Загрузка…' : ''}</span></button>{error && <div role="alert" className="support-error">{error}</div>}</div>;
}
